import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Divider } from 'shared/mui/Divider/Divider';
import { Stack } from 'shared/mui/Stack/Stack';

import { BoxStyled } from './RequestsBankOpsForm.styled';

export const RequestsBankOpsFormSkeleton: React.FC = () => {
  return (
    <Box paddingY="24px" width="100%">
      <BoxStyled sx={{ gap: '24px' }}>
        <Skeleton height={40} variant="rounded" />
        <Skeleton height={40} variant="rounded" />
        <Skeleton height={40} sx={{ gridColumn: '3 / span 2' }} variant="rounded" />
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton height={40} key={index} variant="rounded" />
        ))}
      </BoxStyled>
      <Skeleton
        height={24}
        sx={{ marginBottom: '20px', marginLeft: '10px', marginTop: '24px' }}
        variant="rounded"
        width={260}
      />
      <Divider orientation="horizontal" sx={{ marginBottom: 3, marginTop: '4px' }} />
      <Skeleton height={56} variant="rounded" width="100%" />
      <Stack direction="row" gap={2} justifyContent="flex-end" mt="24px">
        <Skeleton height={36} variant="rounded" width={100} />
        <Skeleton height={36} variant="rounded" width={116} />
      </Stack>
    </Box>
  );
};
